module.exports = __webpack_public_path__ + "static/media/people-group.1183a04b.svg";